import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { ChatComponent } from './components/chat/chat.component';
import { LoginComponent } from './components/admin/login/login.component';
import { DashboardComponent } from './components/admin/dashboard/dashboard.component';
import { ComplaintsComponent } from './components/admin/complaints/complaints.component';
import { FaqManagementComponent } from './components/admin/faq-management/faq-management.component';
import { AnalyticsComponent } from './components/admin/analytics/analytics.component';
import { SettingsComponent } from './components/admin/settings/settings.component';
import { ConversationLogComponent } from './components/admin/conversation-log/conversation-log.component';
import { AdminLayoutComponent } from './components/admin/layout/admin-layout.component';
import { KnowledgebaseComponent } from './components/admin/knowledgebase/knowledgebase.component';
import { QuestionnaireComponent } from './components/questionnaire/questionnaire.component';
import { routes } from './app.routes';
import { AuthGuard } from './guards/auth.guard';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';

@NgModule({
  declarations: [AppComponent, ChatComponent, LoginComponent, DashboardComponent, FaqManagementComponent, ComplaintsComponent, ConversationLogComponent, AdminLayoutComponent, KnowledgebaseComponent, QuestionnaireComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes),
    AnalyticsComponent,
    SettingsComponent
  ],
  providers: [AuthGuard, { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule {}

